import axios from "axios";

const saveLineApiPg = async (body) => {
  const token = localStorage.getItem("token");
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_URL_BACKEND}api/v1/lines`,

      body,
      {
        headers: {
          Authorization: token ? `Bearer ${token}` : "",
        },
      }
    );
    const data = await res.data;
    return {data, res};
  } catch (error) {
    console.error(error);
  }
};

export default saveLineApiPg;
